import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from '../Card/Card';
import Text from '../Text/Text';
import Button from '../Button/Button';
import ButtonTypes from '../../constants/buttonTypes';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Card
      showHeader={false}
      styleContainer="pb-[30px] w-full flex justify-center items-center h-max"
    >
      <Text text="Access Denied" bold textStyle="text-[32px] text-center w-full mb-[20px]" />
      <Text
        text={'You don\'t have permissions to access this page.'}
        muted
        textStyle="text-[14px] text-center w-full mb-[3px]"
      />
      <Text
        text="Contact an administrator to get permissions or go to he home page"
        muted
        textStyle="text-[14px] text-center w-full mb-[3px]"
      />
      <Text
        text="and browse other pages"
        muted
        textStyle="text-[14px] text-center w-full mb-[3px]"
      />
      <div className="flex justify-center">
        <Button
          type={ButtonTypes.INFO}
          text="Go to home"
          containerStyle="mt-[30px] w-[150px]"
          onClick={() => navigate('/')}
        />
      </div>
    </Card>
  );
};

AccessDenied.propTypes = {};

AccessDenied.defaultProps = {};

export default AccessDenied;
